import { IIngredient } from './IIngredient'
import { StockCard } from './IStockCard' // Uncomment if needed for stock card linkage

export interface IIngredientRequest {
  ingredientRequestId: string
  ingredientRequestDisplayId: string
  inOutDirection: string
  sourceOrDestination: string
  stockCard: StockCard | null
  ingredients: Partial<IIngredient>[]
  notes: string
  batchNumber: string
  createdBy?: string
  createdAt: Date | string | null
  status?: string
}

export class IngredientRequest implements IIngredientRequest {
  ingredientRequestId: string
  ingredientRequestDisplayId: string
  inOutDirection: string
  sourceOrDestination: string
  stockCard: StockCard | null
  ingredients: Partial<IIngredient>[]
  notes: string
  batchNumber: string
  createdBy?: string
  createdAt: Date | string | null
  status?: string

  constructor({
    ingredientRequestId,
    ingredientRequestDisplayId,
    inOutDirection,
    sourceOrDestination,
    stockCard,
    ingredients,
    notes,
    batchNumber,
    createdBy,
    createdAt,
    status,
  }: Partial<IIngredientRequest> = {}) {
    this.ingredientRequestId = ingredientRequestId ?? ''
    this.ingredientRequestDisplayId = ingredientRequestDisplayId ?? ''
    this.inOutDirection = inOutDirection ?? ''
    this.sourceOrDestination = sourceOrDestination ?? ''
    this.stockCard = stockCard ?? null
    this.ingredients = ingredients ?? []
    this.notes = notes ?? ''
    this.batchNumber = batchNumber ?? ''
    this.createdBy = createdBy ?? ''
    this.createdAt = createdAt ?? null
    this.status = status ?? ''
  }
}

export enum IngredientRequestSourceOrDestination {
  rndIn = 'RnD Masuk',
  rndOut = 'RnD Keluar',
  adjustment = 'Adjustment',
  adjustmentProduction = 'Adjustment (Produksi)',
  inNoCost = 'Masuk Tanpa Biaya',
  outNoCost = 'Keluar Tanpa Biaya',
  productionAdditionalRequest = 'produksi request tambahan',
  stokQc = 'stok qc',
  purchaseReturn = 'purchaseReturn',
  outWithCost = 'Barang dikeluarkan dengan biaya (wajib tulis tujuan mana di notes)',
}
